import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import {
  BehaviorSubject,
  catchError,
  EMPTY,
  firstValueFrom,
  ignoreElements,
  Observable,
  of,
  switchMap,
  take,
  tap,
} from 'rxjs';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';
import {

  UserWithToken,
} from '../interface/usuario.interface';
import { UserI } from 'src/app/interfaces/user.interface';

export const USER_COOKIE_KEY = 'x-token';

@Injectable({
  providedIn: 'root',
})
export class PermisosAuthService {
  private user = new BehaviorSubject<UserWithToken | null>(null);

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
    private readonly cookie: CookieService
  ) { }

  private url = environment.url;

  login(user: string, password: string, param: any) {
    let url = this.url + 'permisos-usuarios/auth/login';

    return this.http
      .post<UserWithToken>(url, {
        username: user,
        password: password,
      })
      .pipe(
        tap((userToken) =>
          this.saveTokenToCookie(userToken.token.access_token)
        ),
        // tap((userToken) => this.saveUserToLocalStorage(userToken.user)),
        tap((userToken) => this.pushNewUser(userToken)),
        tap(() => this.redirect(param)),
        ignoreElements()
      );
  }

  private redirect(param: any) {
    if (!this.user.getValue()?.user.first_login) {
      if (param) this.router.navigate([param]);
      else this.router.navigate(['permisos']);
    } else {
      this.router.navigate(['change-pass']);
    }
  }

  logout() {
    this.removeUserFromCookie();
    this.removeUserFromLocalStorage();
    this.user.next(null);
    this.router.navigate(['login'], { replaceUrl: true });
  }

  private pushNewUser(user: UserWithToken) {
    this.user.next(user);
  }

  saveTokenToCookie(token: string) {
    this.cookie.set(USER_COOKIE_KEY, token, undefined, '/');
  }

  private removeUserFromCookie() {
    this.cookie.set(USER_COOKIE_KEY, '', undefined, '/');
  }

  private removeUserFromLocalStorage() {
    localStorage.removeItem('user-info');
  }

  // TODO
  async returnUserInfo() {
    let direction = `${this.url}users/user-info`;
    try {
      const userData = await firstValueFrom(
        this.user.pipe(
          take(1),
          switchMap((data) => {
            if (data == null) {
              return this.http.get<UserWithToken>(direction).pipe(
                tap((userToken) => this.pushNewUser(userToken)),
                catchError((error) => {
                  this.logout();
                  handleError(error);
                  return EMPTY;
                })
              );
            } else return of(data);
          })
        )
      );
      if (userData) return userData.user;
      else {
        this.logout();
        return null;
      }
    } catch (error) {
      this.logout();
      return null;
    }
  }


  // TODO
  getUserInfoById(userId: number): Observable<UserI> {
    const direction = `${this.url}users/${userId}/info`;
    return this.http.get<UserI>(direction);
  }

  // TODO
  resetPassword(email: string) {
    const direction = `${this.url}users/reset-password`;
    return this.http.post(direction, { email: email }).pipe();
  }

  checkToken(token: string) {
    return this.http.post<boolean>(this.url, { token });
  }
}
